// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPartialUserItem,
}                               from '../interfaces';

const createAnonymousUser = async ({
    test,
    firstName,
    lastName,
    phoneNumber,
    photoURL,
}: {
    test: boolean,
    firstName: string,
    lastName: string,
    phoneNumber?: string,
    photoURL?: string,
}): Promise<IPartialUserItem> => {
    const functions = getFunctions();
    const handleCreateAnonymousUser = httpsCallable<
        Record<
            string,
            boolean | string | undefined
        >,
        IPartialUserItem
    >(
        functions,
        'createAnonymousUser',
    );
    return handleCreateAnonymousUser({
        test,
        firstName,
        lastName,
        phoneNumber,
        photoURL,
    }).then((result) => {
        const partialUser = result.data as IPartialUserItem;
        return partialUser;
    }).catch((err) => {
        throw err;
    });
};

export default createAnonymousUser;
